import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCustomerServiceProfileList extends Layout {
    layoutheaderCustomerServiceProfileList: LayoutHeader;
    sourceCsmProfile: DataSource;
    tableCsmProfiles: Table;
}
